'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useUtilsCfb96ac9 = require('./useUtils-cfb96ac9.js');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
var makePickerWithState5a79cb8a = require('./makePickerWithState-5a79cb8a.js');
var Wrapper241966d7 = require('./Wrapper-241966d7.js');
var Clock48fde975 = require('./Clock-48fde975.js');
var makeStyles = require('../../core/esm/styles/makeStyles.js');
var useTheme = require('../../core/esm/styles/useTheme.js');

var useStyles = makeStyles({
  toolbarLandscape: {
    flexWrap: 'wrap'
  },
  toolbarAmpmLeftPadding: {
    paddingLeft: 50
  },
  separator: {
    margin: '0 4px 0 2px',
    cursor: 'default'
  },
  hourMinuteLabel: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  hourMinuteLabelAmpmLandscape: {
    marginTop: 'auto'
  },
  hourMinuteLabelReverse: {
    flexDirection: 'row-reverse'
  },
  ampmSelection: {
    marginLeft: 20,
    marginRight: -20,
    display: 'flex',
    flexDirection: 'column'
  },
  ampmLandscape: {
    margin: '4px 0 auto',
    flexDirection: 'row',
    justifyContent: 'space-around',
    flexBasis: '100%'
  },
  ampmSelectionWithSeconds: {
    marginLeft: 15,
    marginRight: 10
  },
  ampmLabel: {
    fontSize: 18
  }
}, {
  name: 'MuiPickersTimePickerToolbar'
});
function useMeridiemMode(date, ampm, onChange) {
  var utils = useUtilsCfb96ac9.u();
  var meridiemMode = Clock48fde975.g(date, utils);
  var handleMeridiemChange = React.useCallback(function (mode) {
    var timeWithMeridiem = Clock48fde975.c(date, mode, Boolean(ampm), utils);
    onChange(timeWithMeridiem, false);
  }, [ampm, date, onChange, utils]);
  return {
    meridiemMode: meridiemMode,
    handleMeridiemChange: handleMeridiemChange
  };
}
var TimePickerToolbar = function TimePickerToolbar(_ref) {
  var date = _ref.date,
      views = _ref.views,
      ampm = _ref.ampm,
      openView = _ref.openView,
      onChange = _ref.onChange,
      isLandscape = _ref.isLandscape,
      setOpenView = _ref.setOpenView;
  var utils = useUtilsCfb96ac9.u();
  var theme = useTheme();
  var classes = useStyles();

  var _useMeridiemMode = useMeridiemMode(date, ampm, onChange),
      meridiemMode = _useMeridiemMode.meridiemMode,
      handleMeridiemChange = _useMeridiemMode.handleMeridiemChange;

  var clockTypographyVariant = isLandscape ? 'h3' : 'h2';
  return React.createElement(makePickerWithState5a79cb8a.P, {
    isLandscape: isLandscape,
    className: clsx_m(isLandscape ? classes.toolbarLandscape : ampm && classes.toolbarAmpmLeftPadding)
  }, React.createElement("div", {
    className: clsx_m(classes.hourMinuteLabel, ampm && isLandscape && classes.hourMinuteLabelAmpmLandscape, {
      rtl: classes.hourMinuteLabelReverse
    }[theme.direction])
  }, Wrapper241966d7.a(views, 'hours') && React.createElement(makePickerWithState5a79cb8a.T, {
    variant: clockTypographyVariant,
    onClick: function onClick() {
      return setOpenView(Clock48fde975.b.HOURS);
    },
    selected: openView === Clock48fde975.b.HOURS,
    label: utils.getHourText(date, Boolean(ampm))
  }), Wrapper241966d7.a(views, ['hours', 'minutes']) && React.createElement(makePickerWithState5a79cb8a.c, {
    label: ":",
    variant: clockTypographyVariant,
    selected: false,
    className: classes.separator
  }), Wrapper241966d7.a(views, 'minutes') && React.createElement(makePickerWithState5a79cb8a.T, {
    variant: clockTypographyVariant,
    onClick: function onClick() {
      return setOpenView(Clock48fde975.b.MINUTES);
    },
    selected: openView === Clock48fde975.b.MINUTES,
    label: utils.getMinuteText(date)
  }), Wrapper241966d7.a(views, ['minutes', 'seconds']) && React.createElement(makePickerWithState5a79cb8a.c, {
    variant: "h2",
    label: ":",
    selected: false,
    className: classes.separator
  }), Wrapper241966d7.a(views, 'seconds') && React.createElement(makePickerWithState5a79cb8a.T, {
    variant: "h2",
    onClick: function onClick() {
      return setOpenView(Clock48fde975.b.SECONDS);
    },
    selected: openView === Clock48fde975.b.SECONDS,
    label: utils.getSecondText(date)
  })), ampm && React.createElement("div", {
    className: clsx_m(classes.ampmSelection, isLandscape && classes.ampmLandscape, Wrapper241966d7.a(views, 'seconds') && classes.ampmSelectionWithSeconds)
  }, React.createElement(makePickerWithState5a79cb8a.T, {
    disableRipple: true,
    variant: "subtitle1",
    selected: meridiemMode === 'am',
    typographyClassName: classes.ampmLabel,
    label: utils.getMeridiemText('am'),
    onClick: function onClick() {
      return handleMeridiemChange('am');
    }
  }), React.createElement(makePickerWithState5a79cb8a.T, {
    disableRipple: true,
    variant: "subtitle1",
    selected: meridiemMode === 'pm',
    typographyClassName: classes.ampmLabel,
    label: utils.getMeridiemText('pm'),
    onClick: function onClick() {
      return handleMeridiemChange('pm');
    }
  })));
};

exports.T = TimePickerToolbar;
exports.u = useMeridiemMode;
